

export class Usuario {
    constructor(
        public nombre: string,
        public rut: string,
        public _id?: string,
        public doc_id?: number,
        public doc_lme?: boolean,
        public email?: string,
        public nombre_usuario?: string,
        public typ_id?: number,
        public typ_name?: string,
        public use_maternal_surname?: string,
        public use_name?: string,
        public use_paternal_surname?: string,
        public use_sta_id?: number,
        public user?: string,
        public cou_id?: string,
        public cou_name?: string,
        public cou_end_url?: string,
        public cou_timezone?: string,
        public cou_language?: string,
        public telefono?: string,
        public doc_check_modal_vl?: boolean,
        public doc_enrolled?: boolean,
        public doc_ondemand?: boolean,
        public doc_check_can_self_schedule?: boolean,
        public doc_check_can_use_digital_pad?: boolean,
        public doc_check_can_create_prescriptions?: boolean,
        public doc_check_can_create_orders?: boolean,
        public doc_check_can_create_certificates?: boolean
    ) { }
}